import React from "react";
import { Box } from "@mui/material";
import i18n from "../../i18n";
// import ReactPlayer from "react-player";
import { H2, H6 } from "../../components/typography";
import { COLORS } from "../../theme";
import {imgContinue} from "../../assets/images/continue";

const QuizReady = (props) => {
  const handleContinue = () => {
    if (props.handleContinue) props.handleContinue();
  };

  // const onTimelineEnd = () => {
  //   handleContinue();
  // }

  return (
    <Box sx={{
      marginTop: { xs: 10, md: 20 },
    }}>
      <H2 fontWeight="bold" color={COLORS.white}>
        {i18n.t("get_ready")}
      </H2>

     {/* <ReactPlayer
        className="timeline"
        url={'/timeline.mp4'}
        controls={false}
        playing
        muted
        playsinline
        width={null}
        height="28px"
        onEnded={onTimelineEnd}
      />*/}

      <img src={`/timeline.gif?time=${Date.now()}`}
        style={{
          height: '16px',
          width: '100%',
          marginTop: 15
        }}
      />

      <H6 color={COLORS.white}>{i18n.t("get_ready_information")}</H6>

      <Box
        component="img"
        sx={{
          height: { xs: 50, md: 75 },
          width: { xs: 180, md: 270 },
        }}
        alt="continue button"
        src={`${imgContinue}`}
        onClick={handleContinue}
      />
    </Box>
  );
};

export default QuizReady;
